import React from 'react';
import { Clock, CheckCircle2, XCircle } from 'lucide-react';
import { Badge } from '../ui/badge';

export function StatusBadge({ status }) {
  switch (status) {
    case 'completed':
      return <Badge className="bg-green-100 text-green-700 border-green-200"><CheckCircle2 className="w-3 h-3 mr-1" />Completed</Badge>;
    case 'in_progress':
      return <Badge className="bg-blue-100 text-blue-700 border-blue-200"><Clock className="w-3 h-3 mr-1" />In Progress</Badge>;
    case 'missed':
      return <Badge className="bg-red-100 text-red-700 border-red-200"><XCircle className="w-3 h-3 mr-1" />Missed</Badge>;
    case 'cancelled':
      return <Badge className="bg-slate-100 text-slate-700 border-slate-200"><XCircle className="w-3 h-3 mr-1" />Cancelled</Badge>;
    default:
      return <Badge variant="outline">Scheduled</Badge>;
  }
}
